__turbopack_context__.v({
  "checkboxInput": "k-DG9a_checkboxInput",
  "checkboxLabel": "k-DG9a_checkboxLabel",
  "checkboxRequiredMark": "k-DG9a_checkboxRequiredMark",
  "checkboxWrapper": "k-DG9a_checkboxWrapper",
  "primary": "k-DG9a_primary",
  "secondary": "k-DG9a_secondary",
  "striked": "k-DG9a_striked",
});
